import { render } from "./ExperienceYears.vue?vue&type=template&id=80d637e4"
import script from "./ExperienceYears.vue?vue&type=script&lang=js"
export * from "./ExperienceYears.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__